'use client';

import { useEffect } from 'react';
import { DEFAULT_THEME, THEME } from '../../model/config';

function ThemeWrapper({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    const cookieTheme = document.cookie
      .split('; ')
      .find((row) => row.startsWith('theme='))
      ?.split('=')[1];
    const theme =
      cookieTheme === THEME.DARK || cookieTheme === THEME.LIGHT
        ? cookieTheme
        : DEFAULT_THEME;

    document.documentElement.setAttribute('data-theme', theme);
  }, []);

  return <>{children}</>;
}

export default ThemeWrapper;
